<template>
  <div class="cool-toast" @touchmove.prevent>
    <transition name="toast">
      <div class="mask" v-if="animationShow" :class="[type, toast.class]">
        <div class="toast-content" v-show="type==='toast'">
          <i class="iconfont" :class="toast.icon" v-if="toast.icon"></i>
          <p>{{toast.msg}}</p>
        </div>
        <div class="toast-content loading-content" v-show="type==='loading'">
          <img src="../assets/loading.gif" alt="">
          <p v-show="toast.msg">{{toast.msg}}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
let customData = {
  msgTimeout: ''
}

export default {
  name: 'toast',
  data() {
    return {
      msg: '',
      toast: {},
      animationShow: false,
      type: ''
    }
  },
  mounted() {
    this.$on('toast', data => {
      this.type = 'toast'
      if (typeof data === 'string') {
        this.toast.msg = data
      } else if (typeof data === 'object') {
        Object.assign(this.toast, data)
      }
      this.animationShow = true
      if (this.toast.msg) {
        clearTimeout(customData.msgTimeout)
      }
      customData.msgTimeout = setTimeout(() => {
        this.toast = {}
        this.animationShow = false
      }, data.timeout || 2000)
    })
    this.$on('loading', () => {
      this.type = 'loading'
      this.animationShow = true
    })
    this.$on('loadingClose', () => {
      this.animationShow = false
    })
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.cool-toast{
  .mask {
    @extend %all-mask;
    @extend %flex-center;
    &.loading,&.no-mask{
      background-color: transparent;
    }
  }
  .toast-content{
    padding: 15px 25px;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, .6);
    color: #FFFFFF;
    display: inline-block;
    max-width: 400px;
    text-align: center;
    .iconfont{
      display: inline-block;
      &.success{
        font-size: 100px;
        margin: 0 30px 10px;
        color: $primary-color;
      }
    }
  }
  .loading-content{
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    img{
      width: 60px;
      height: 60px;
    }
  }
  .toast-enter-active, .toast-leave-active{
    transition: opacity .3s;
  }
  .toast-enter{
    opacity: 0;
  }
  .toast-enter-to{
    opacity: 1;
  }
  .toast-leave-to{
    opacity: 0;
  }
}
</style>
